import React, { useState, useEffect } from "react";
import {
  useFetchAllSportsQuery,
  useFetchProfilesQuery,
  useFetchAllNewsTypeQuery,
} from "../../store/api/apiSlice";
import FadeInAnimation from "../animations/FadeInAnimation";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
const SportSection = ({ selected, setSelected, image, setImage }) => {
  const {
    data: sportsData,
    isLoading: isSportsLoading,
    refetch: refetchSportsData,
  } = useFetchAllSportsQuery();

  const {
    data: profileData,
    isLoading: isProfileLoading,
    refetch: refetchProfileData,
  } = useFetchProfilesQuery();

  const { data: NewsData, isLoading: isNewsLoading } = useFetchAllNewsTypeQuery(
    profileData?.user?._id,
    { skip: !profileData?.user?._id }
  );
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const [initialSelectedSports, setInitialSelectedSports] = useState([]);

  useEffect(() => {
    refetchProfileData();
    refetchSportsData();
  }, []);
  useEffect(() => {
    if (profileData && profileData.user) {
      const { favorite_sports = [] } = profileData.user;
      const favoriteSports = favorite_sports[0]
        ? JSON.parse(favorite_sports[0])
        : [];
      const selectedSports = favoriteSports
        .map((athlete) => athlete.name)
        .slice(0, 3)
        .concat(Array(3).fill(""))
        .slice(0, 3);
      setInitialSelectedSports(selectedSports);
    } else {
    }
  }, [profileData]);
  const getMatchedSports = () => {
    if (!sportsData || !sportsData.sports) return [];

    return initialSelectedSports
      .map((selectedSport) => {
        return sportsData.sports.find((sport) => sport.name === selectedSport);
      })
      .filter((sport) => sport);
  };

  const matchedSports = getMatchedSports();
  const handleClick = (value) => {
    setSelected(value);
  };
  const handleImageClick = (sportName) => {
    setImage(sportName);
    if (selected) {
      const matchedData = NewsData?.newsTypeLinks.find(
        (news) => news.newsType === selected && news.sportsName === sportName
      );

      if (matchedData) {
        window.open(matchedData.resource_URL, "_blank");
      } else {
        toast.error("No matching data found.");
      }
    }
  };
  return (
    <div>
      <div className="card-body" style={{ paddingBottom: "0px" }}>
        <FadeInAnimation>
          <div
            className="d-flex  align-items-center"
            style={{ justifyContent: "space-around" }}
          >
            <div
              onClick={() => handleClick("recruiting")}
              style={{ cursor: "pointer", marginBottom: "8px" }}
            >
              <span
                style={{
                  padding: "10px",
                  backgroundColor:
                    selected === "recruiting" ? "antiquewhite" : "transparent",
                  borderRadius: selected === "recruiting" ? "15px" : "0",
                  transition: "background-color 0.3s, border-radius 0.3s",
                }}
              >
                Recruit
              </span>
            </div>
            <div
              className="Nil_main"
              onClick={() => handleClick("nil")}
              style={{ cursor: "pointer", marginBottom: "8px" }}
            >
              <span
                style={{
                  padding: "10px",
                  backgroundColor:
                    selected === "nil" ? "antiquewhite" : "transparent",
                  borderRadius: selected === "nil" ? "15px" : "0",
                  transition: "background-color 0.3s, border-radius 0.3s",
                }}
              >
                NIL
              </span>{" "}
            </div>
            <div
              onClick={() => handleClick("xfr")}
              style={{
                cursor: "pointer",
                marginBottom: "8px",
                marginRight: "-10px",
              }}
            >
              <span
                style={{
                  padding: "10px",
                  backgroundColor:
                    selected === "xfr" ? "antiquewhite" : "transparent",
                  borderRadius: selected === "xfr" ? "15px" : "0",
                  transition: "background-color 0.3s, border-radius 0.3s",
                }}
              >
                XFRPORT
              </span>
            </div>
          </div>
        </FadeInAnimation>
      </div>

      <div className="card-body">
        <div
          className="d-flex align-items-center mb-3"
          style={{ justifyContent: "space-around" }}
        >
          {(isSportsLoading || isProfileLoading) &&
            Array(3)
              .fill(0)
              .map((_, index) => (
                <div key={index} style={{ padding: "4px" }}>
                  <Skeleton circle={true} height={50} width={50} />
                </div>
              ))}
          {!isSportsLoading &&
            !isProfileLoading &&
            matchedSports.map((sport, index) => (
              <FadeInAnimation>
                <div
                  key={sport._id}
                  onClick={() => handleImageClick(sport.name)}
                  style={{
                    cursor: "pointer",
                    backgroundColor:
                      image === sport.name ? "antiquewhite" : "transparent",
                    borderRadius: image === sport.name ? "15px" : "0",
                    transition: "background-color 0.3s, border-radius 0.3s",
                    padding: "4px",
                  }}
                >
                  <img
                    src={`${baseUrl}/${sport.sportsFile}`}
                    alt={sport.name}
                    className="ballicon"
                  />
                </div>
              </FadeInAnimation>
            ))}
        </div>
      </div>
    </div>
  );
};

export default SportSection;
